import { NewButton } from "components/NewButton/NewButton";
import { DatoComponentsWrapper } from "components/common/DatoComonentsWrappeer/DatoComponentsWrapper";
import { useTranslationContext } from "context/translation";
import Link from "next/link";
import { FC } from "react";
import { ComponentsWrapperFragment } from "services/datocms/generated";

type EmptyCartProps = {
  components?: ComponentsWrapperFragment | null;
};

export const EmptyCart: FC<EmptyCartProps> = ({ components }) => {
  const { cartEmpty, startShopping } = useTranslationContext();

  return (
    <div>
      <div className="px-6 pt-10 md:pt-20 pb-12 md:pb-[100px] flex flex-col justify-start items-center gap-4">
        <h1 className="text-primary text-2xl">{cartEmpty}</h1>
        <Link href="/">
          <NewButton>{startShopping}</NewButton>
        </Link>
      </div>
      <DatoComponentsWrapper components={components} />
    </div>
  );
};
